import React, { ReactNode } from "react";
import "./IconButton.css";

interface Props {
  onClick: () => void;
  icon: string | ReactNode;
  disabled?: boolean;
  title?: string;
  mini?: boolean;
  strikethrough?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
  highlight?: boolean;
}

function IconButton(props: Props) {
  const handleClick = () => {
    props.onClick();
  };

  const miniCss = props.mini ? "mini-button" : "";
  const strikeCss = props.strikethrough ? "strikethrough" : ""
  const highlightCss = props.highlight ? "highlight" : "";
  const className = `icon-button-wrapper ${miniCss} ${strikeCss} ${highlightCss}`;

  return (
    <span className={className}>
      <button
        ref={props.ref}
        type="button"
        title={props.title}
        onClick={handleClick}
        disabled={props.disabled}
        aria-disabled={props.disabled}
      >
        {props.icon}
      </button>
    </span>
  );
}

export default IconButton;
